/**
 * Converts a pathname to its canonical form by adding a trailing slash if needed
 * Does not modify pathnames that:
 * - Are the root path (/)
 * - Already end with a slash
 * - Have a file extension
 */
export const toCanonicalPathname = (pathname: string): string => {
  // Return as-is if root path
  if (pathname === '/') {
    return pathname
  }

  // Return as-is if already has trailing slash
  if (pathname.endsWith('/')) {
    return pathname
  }

  // Return as-is if has file extension
  if (pathname.includes('.')) {
    return pathname
  }

  // Add trailing slash
  return `${pathname}/`
}
